// extracted by mini-css-extract-plugin
export default {"exactnessButton":"ExactnessButton_exactnessButton__Ajcsk","inputBox":"ExactnessButton_inputBox__bbqx4"};